
export const fetchShipmentByAccountNumber = async (payload) => {
    const { accountNumber, shipmentDate, prefix, airWaybillNumber,tenderedDate,origin,destination} = payload;

    const params = new URLSearchParams({
        prefix: prefix,
        airWaybillNumber: airWaybillNumber,
        accountNumber: accountNumber,
        shipmentDate: shipmentDate.substring(0, 10),
        tenderedDate: tenderedDate.substring(0, 10),
        client_id: 'P502071',
        origin: origin,
        destination: destination

    });

    const apiUrl = `${global.config.trackingServiceUrl}?${params.toString()}`;

    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    const data = await response.json();
    return data;
};



// WEBPACK FOOTER //
// ./src/api/shipmentByAccountNumberApi.js